export default function buildAccessibilityMessage(errorCount) {
  return errorCount === 1 ?
    'There is 1 error in the form.' :
    `There are ${errorCount} errors in the form.`;
}
